import { useEffect, useState } from "@wordpress/element";
import { useBlockProps } from "@wordpress/block-editor";
import { FocusableIframe } from "@wordpress/components";
import apiFetch from "@wordpress/api-fetch";
import "./editor.scss";

export default function Edit({ attributes }) {
    const blockProps = useBlockProps();
    const [partnerToken, setPartnerToken] = useState("");

    useEffect(() => {
        apiFetch({ path: "/wp/v2/settings" }).then((settings) => {
            setPartnerToken(settings?.werstreamtes_widget_partner_token || "");
        });
    }, []);

    const params = new URLSearchParams({
        filterUrl: attributes.filterUrl || "",
        hideEntryWithoutProvider: String(attributes.hideEntryWithoutProvider),
        limit: String(attributes.limit),
        providers: Array.isArray(attributes.selectedProviders)
            ? attributes.selectedProviders.join(",")
            : String(attributes.selectedProviders || ""),
        showNumbers: String(attributes.showNumbers),
        style: String(attributes.style || ""),
        tag: partnerToken
    });

    return (
        <div {...blockProps}>
            {attributes.filterUrl ? (
                <FocusableIframe
                    src={`https://www.werstreamt.es/widgets/filter/embed/?${params.toString()}`}
                />
            ) : (
                "Hier klicken um das WerStreamt.es Widget zu konfigurieren."
            )}
        </div>
    );
}
